import React from 'react';
import GIECard from '../../components/GIECard/GieCard';
import GIESvgIcon from "../GIEIcon/GIESvgIcon";
import enveloppeIcon from "../../assets/icon/envelope.svg";

export default class MessageSuccess extends React.Component<any, any> {
  render() {
    return (
      <div>
        <GIECard width="100%" height="50vh" contentFullHeight>
          <div className="d-flex h-100 justify-content-center align-items-center flex-column">
            <div className="mb-5">
              <GIESvgIcon big icon={enveloppeIcon}/>
            </div>
            <h4>Nous avons bien reçu votre demande qui sera traitée dans les meilleurs délais</h4>
          </div>
        </GIECard>
      </div>
    );
  }
}
